import axios from 'axios'

export default {
    getSection(){
        return axios.get('/section')
            .then(response => {
                return response.data
            })
    },
    getSectionDataSource(params){
        return axios.get('/section/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getSectionbyID(id){
        return axios.get('/section/' + id)
            .then(response => {
                return response.data
            })
    },    
    createSection(formdata){
        return axios.post('/section', formdata)
            .then(response => {
                return response.data
            })
    },
    updateSection(id,formdata){
        return axios.put('/section/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateSection(id){
        return axios.put('/section/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateSection(id){
        return axios.put('/section/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    destroySection(id){
        return axios.delete('/section/' + id)
            .then(response => {
                return response.data
            })
    },
    getSectionOrderList(){
        return axios.get('/section/orderlist')
            .then(response => {
                return response.data
            })
    },
    updateSectionOrderList(formdata){
        return axios.post('/section/updatelist', formdata)
            .then(response => {
                return response.data
            })
    },     
}